import React from "react";
import "./layout.css";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";

const BaseLayout = ({ children, isPadding = true }) => {
  return (
    <div className="baselayout-container light-bg-H">
      <div className="sidebar-main light-bg-L">
        <Sidebar />
      </div>
      <div className="header-dasboard main_container" style={{ flex: 1, overflowX: "hidden", display: "flex", flexDirection: "column", height: "100vh" }}>
        <Header />
        <div className={`${isPadding ? "dashboard" : ""}`} style={{ flex: 1, overflowY: "auto" }}>
          <div className="container-fluid main_container">
            <div className="row">
              <div className="col-lg-12 col-sm-12">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BaseLayout;
